<template>

  <div>
    <CartRightSidebarPopupMobile v-if="!confirmLoading" :hasProduct="hasProduct()" :updateCartLoading="updateCartLoading" :additionalServices="additionalServices" :installationServiceStatus="installationServiceStatus" :grand-total="(cartDetails.total || '0.00')" :shippingCharges="cartDetails.shipping_charges" :cartDetails="cartDetails" ></CartRightSidebarPopupMobile>
    <div class="container">
      <div>
        <!-- <b-button v-b-modal.modal-scrollable>Launch scrolling modal</b-button> -->
        <!-- hide-footer hide-header -->
        <b-modal  hide-footer size="md" ref="my-modal" centered scrollable id="cart-freeinstallition-modal" :title="cmsPageContent.title">
          <!-- <b-button class="closeicon" @click="$bvModal.hide('modal-scrollable')"><i class="fas fa-times"></i></b-button> -->
          <!-- <p class="my-4" v-if="cmsPageContent.content" v-html="cmsPageContent.content"></p> -->
          <!-- <template #modal-footer="{ ok}">
            <b>Custom Footer</b>
            <b-button size="lg" variant="success" @click="ok()">
              OK
            </b-button>
          </template> -->

          <template #modal-title>
            <div style="background-color: black;">
              <img style="float: left;height: 73px;padding-right: 20px;" :src="`images/cart-popup/free-delivery-logo_${currentLang}.png`">
              <p style="height: 57px;color: white;font-size: 23px;padding-top: 6px;">{{ $t('Free delivery when you order tires with installion')}}</p>
            </div>
          </template>


          <!-- <div style="border: 2px solid #eda00c;height: 200px; background-color: black; ">
              <div style="margin-top:2%; margin-left: 5%;">
                  <img style="float:left; height: 150px;" src="../../public/images/cart-popup/free-delivery-logo.png">
                  <p style="color: white; font-size: 35px;padding-top: 25px;">Free delivery when you order tires with
                      installion</p>
              </div>
          </div> -->
          <div style="min-height: 600px;margin: 0px 0px 0px -10px;">
            <div>
              <img style="float:left; height: 100px;" :src="`images/cart-popup/flag_${currentLang}.png`" alt="" />
              <h4 style="padding-top: 28px;font-size: large;font-weight: 900;">{{ $t('Finnish service and work')}}</h4>
            </div>
            <div style="clear: both;">
              <hr>
            </div>
            <div style="padding-left: 25px;">
                <h1 style="margin-top: 30px;color: #eda00c;">{{ $t("This is how you do it")}}:</h1>
              <div v-if="cmsPageupdateContent" v-html="cmsPageupdateContent"></div>
              <!-- <p>
                <div class="modal-number">1</div>
                <div style="padding-top: 10px;"> {{ $t("Choose \"installion\" (free delivery)")}} </div>
              </p>
              <p>
                <div class="modal-number">2</div>
                <div style="padding-top: 10px;"> {{ $t("Go to next page and give location or postal code")}} </div>
              </p>
              <p>
                <div class="modal-number">3</div>
                <div style="padding-top: 10px;"> {{ $t("Choose your preferred service point and book installation time")}}</div>
              </p>
              <p>
                <div class="modal-number">4</div>
                <div style="padding-top: 10px;"> {{ $t("Go forward and fill your information")}}</div>
              </p>
              <p>
                <div class="modal-number">5</div>
                <div style="padding-top: 10px;"> {{ $t("Go to overview and check you order")}} </div>
              </p>
              <p>
                <div class="modal-number">6</div>
                <div style="padding-top: 10px;"> {{ $t("Go forward for payment")}} </div>
              </p> -->
            </div>
          </div>
        </b-modal>
      </div>
      <div v-if="confirmLoading" class="loading">
        {{ $t("Please wait while we are confirming your order") }}
      </div>
      <div v-else class="row pt-3">
        <b-container fluid>
          <b-card class="checkout-cart mb-4">
            <b-row>
              <b-col class="col-sm-12 col-lg-12" >
                <b-card no-body>
                  <b-tabs card>
                    <b-tab
                        @click="setActiveTab('Cart')"
                        :active="activeTab === 'Cart'"
                        :title-link-class="{'current' : activeTab === 'Cart', 'active_manual' : (getActiveTabClasses('Cart').indexOf(activeTab) >= 0)}"
                        name="Cart"
                        :href="'/cart'"
                        lazy
                    >
                      <template #title>
                        <div class="tab-title">
                          <div class="tab-number" ref="tabNumber">1</div>
                          <span>{{$t('Cart')}}</span>
                        </div>
                      </template>
                      <div class="checkout-cart mb-4">
                        <div class="row">
                          <div :class="{'col-lg-8' : hasProduct(), 'col-lg-12' : !hasProduct()}" class="col-sm-12 your-cart">
                            <div class="cart-details">
                              <div class="cart-head">
                                <h2 class="float-left">{{ $t("YOUR CART") }} </h2>
                                <b-button
                                    class="float-right"
                                    @click="gotoListPage()"
                                    variant="outline-success"
                                    type="font-weight-bold text-uppercase pt-2 pb-2"
                                >
                                  {{ $t("Continue Shopping") }}
                                </b-button>
                              </div>
                              <div class="my-cart mb-4">
                                <table class="table table-striped cart border">
                                  <thead>
                                  <tr>
                                    <th>{{ $t("Product Name") }}</th>
                                    <th class="text-center">
                                      {{ $t("Price") }}
                                    </th>
                                    <th class="text-center">
                                      {{ $t("Quantity") }}
                                    </th>
                                    <th class="text-right">
                                      {{ $t("Total Price") }}
                                    </th>
                                    <th>&nbsp;</th>
                                  </tr>
                                  </thead>

                                  <tbody v-if="updateCartLoading">
                                  <tr>
                                    <td colspan="5" class=" text-center text-warning font-weight-bold">
                                      {{ $t("Updating cart") }}...
                                    </td>
                                  </tr>
                                  </tbody>
                                  <tbody v-if="hasProduct() && updateCartLoading == false">
                                  <tr v-for="(product, index) in cartProducts" :key="index">
                                    <td data-label="PRODUCT" class="product-list-first" >
                                      <div class="productlist">
                                        <div class="product-image">
                                          <p class="mb-0">
                                            <img :src="product.image" alt=""/>
                                          </p>
                                        </div>

                                        <router-link class="color-black cart-product-name" :to="makeBreadcrumbLink(product)">
                                          {{ product.name }}
                                        </router-link>
                                      </div>
                                      <div class="ml-5 rc-label" v-if="product.is_recycled == '0'">
                                        <small>({{ $t("Recycling fee included") }})</small>
                                      </div>
                                      <div class="d-block ml-5 text-danger set-font-size font-italic font-weight-bold"
                                           v-if="productUpdateError[product.id]">
                                        {{ productUpdateError[product.id] }}
                                      </div>
                                    </td>

                                    <td v-if="product.in_stock == 0" colspan="3"
                                        class="text-center text-danger font-weight-bold">
                                      {{ $t("Sold out") }}
                                    </td>
                                    <td data-label="PRICE" class="text-center"
                                        v-if="product.in_stock > 0"
                                    >
                                      {{ setCurrency(product.net_price_with_rc) }}
                                    </td>
                                    <td data-label="QTY" class="text-center" v-if="product.in_stock > 0" >
                                      <div class="d-block text-danger set-font-size font-italic"
                                           v-if="quantityError[product.id]"
                                      >
                                        {{ $t("Max available qty is") }}
                                        <span class="font-weight-bold">{{ product.available_quantity }}</span>
                                      </div>
                                      <div class="input-group number-spinner">
                                          <span class="input-group-btn"
                                                @click="removeQuantity(product, index)"
                                          >
                                            <button class="btn btn-default" data-dir="up">
                                              <i class="fas fa-minus"></i>
                                            </button>
                                          </span>
                                        <input type="number" pattern="[0-9]{5}" min="1"
                                               class="form-control text-center ml-2 mr-2"
                                               v-model="product.qty"
                                               @change="productUpdate(product)"
                                               @input="productInput(product)"
                                        />
                                        <span class="input-group-btn"
                                              @click="addQuantity(product, index)"
                                        >
                                            <button class="btn btn-default" data-dir="dwn">
                                              <i class="fas fa-plus"></i>
                                            </button>
                                          </span>
                                      </div>
                                    </td>
                                    <td data-label="TOTAL PRICE" class="text-right"
                                        v-if="product.in_stock > 0">
                                      {{ calculatePrice(product.net_price_with_rc,product.qty) }}
                                    </td>
                                    <td class="text-center">
                                      <b-button variant="danger" @click="removeProduct(product)" :disabled="removeLoading">
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </td>
                                  </tr>

                                  <tr v-for="(service, index) in cartDetails.line_items"
                                      :key="index + service.id"
                                      class="text-center">
                                    <td v-if="service.type == 'service'" class="text-left">
                                      <div>
                                        {{ $t("Service") }} -
                                        <span>{{ getServiceName(service.service) }}</span>
                                        <span v-if="service.service.is_price_per_quantity == '1'"> - {{ service.sub_type_id }} {{ $t("inch") }}</span>
                                      </div>

                                      <div class="font-italic" v-if="cartDetails.appointment">
                                        <small>{{ cartDetails.appointment.dealer.company_name}}</small>
                                      </div>
                                    </td>
                                    <td v-if="service.type == 'service'"
                                        v-html="setCurrency(service.unit_price)"></td>
                                    <td v-if="service.type == 'service'">
                                      {{ service.quantity }}
                                    </td>
                                    <td v-if="service.type == 'service'" class="text-right"
                                        v-html="setCurrency(service.sub_total)"
                                    ></td>
                                    <td v-if="service.type == 'service'"></td>
                                  </tr>

                                  <!-- <tr v-if="cartDetails.recycling_line_item">
                                                                  <td><p class="mb-1">{{ $t('Recycling Fees') }}</p></td>
                                                                  <td class="text-center"><span v-html="setCurrency(cartDetails.recycling_line_item.unit_price)"></span></td>
                                                                  <td class="text-center"><span v-html="setCurrencyRecyclingTotalQty()"></span></td>
                                                                  <td data-label="Total"  class="pricetotal text-right"><span v-html="setCurrency(cartDetails.recycling_line_item.sub_total)"></span></td>
                                                                  <td class="empty">&nbsp;</td>
                                                              </tr> -->

                                  <tr v-if="cartDetails.shipping_line_item">
                                    <td>{{ $t("Shipping Charges") }}</td>
                                    <td class="empty">&nbsp;</td>
                                    <td class="empty">&nbsp;</td>
                                    <td data-label="Total" class="pricetotal text-right">
                                      <span v-html="setCurrency(cartDetails.shipping_charges)"></span>
                                    </td>
                                    <td class="empty">&nbsp;</td>
                                  </tr>
                                  <tr v-if="cartDetails.promo_code_id">
                                    <td v-if="cartDetails.promo_code_id" class="total text-right" colspan="3">
                                      {{ $t("Discount") }}
                                    </td>
                                    <td v-if="cartDetails.promo_code_id"
                                        class="pricetotal text-right text-success font-weight-bold">
                                      <span v-html="setCurrency(cartDetails.discount_amount)"></span>
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td class="text-right total" colspan="3">
                                      {{ $t("Total") }}
                                    </td>
                                    <td data-label="Total"
                                        class="pricetotal text-right font-weight-bold"
                                        v-html="setCurrency(cartDetails.total)"></td>
                                    <td></td>
                                  </tr>
                                  </tbody>
                                  <tbody v-else>
                                  <tr v-if="updateCartLoading == false">
                                    <td colspan="12" style="text-align: center">
                                      {{ $t("No Product in Cart") }}
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <div class="text-center mt-4" v-if="!hasProduct() && updateCartLoading == false">
                                  <router-link
                                      :to="go_to_products(null,{
                                        width: 205,
                                        height: 55,
                                        diameter: 16
                                      })"
                                      class="btn btn-add-cart rounded-5 text-center bg-green color-white">
                                    {{ $t("Add products to cart") }}
                                  </router-link>
                                </div>
                              </div>

                              <div class="" v-if="hasProduct()">

                                <b-button
                                    v-if="!promocodeToggle"
                                    @click="promocodeToggle = ! promocodeToggle"
                                    variant="outline-success"
                                    type="font-weight-bold text-uppercase pt-2 pb-2"
                                >
                                  {{ $t("Promocode") }}
                                </b-button>

                                <span v-if="promocodeToggle" class="font-weight-bold">{{
                                    $t("Promocode")
                                  }}</span>

                                <span v-if="promocodeToggle">
                                  <span class="pl-3" v-if="!promoLoading">
                                    <b-input
                                        type="text"
                                        v-model.trim="promocodeDiscount"
                                        class="promo-code d-inline-block mr-2"
                                        :class="
                                        promocodeEmpty
                                          ? 'border border-danger'
                                          : ''
                                      "
                                    >
                                    </b-input>

                                    <b-button
                                        v-if="!cartDetails.promo_code_id"
                                        @click="applyCode()"
                                        variant="outline-success"
                                        :disable="promoLoading"
                                        type="font-weight-bold text-uppercase pt-2 pb-2"
                                    >
                                      {{ $t("Apply") }}
                                    </b-button>
                                    <b-button
                                        v-else
                                        @click="removeCode()"
                                        variant="outline-danger"
                                        :disable="promoLoading"
                                        type="font-weight-bold pt-2 pb-2"
                                    >
                                      {{ $t("Remove") }}
                                    </b-button>
                                    <div v-if="promocodeErrors && promocodeErrors.length > 0" class="pl-0 ml-0 mr-5 pr-5">
                                      <span class="promo-error font-italic set-font-size"
                                            v-for="(error, key) in promocodeErrors"
                                            :key="key"
                                      >
                                        {{ $t(error) }}
                                      </span>
                                    </div>
                                  </span>
                                  <span class="pl-3" v-else>
                                    <div class="loading"></div>
                                  </span>
                                </span>
                              </div>
                              <div class="mt-2" v-if="hasTruckTyre">
                                <p class="mb-0 font-italic cs-total-box">{{ $t("If you have truck tyres in your cart, we are unable to offer installation services. The tyres will be shipped to your selected address.") }}</p>
                              </div>

                              <div v-if="hasProduct()" class="mt-4 mb-5">
                                <h2 v-if="hasTruckTyre">{{ $t("Delivery only") }}</h2>
                                <h2 v-else>{{ $t("select installation or delivery only") }}</h2>
                                <hr v-if="additionalServices.filter(additionalService => additionalService.id == 1).length && !hasTruckTyre">
                                <div class="optional-service" v-if="!servicesLoading && additionalServices.filter(additionalService => additionalService.id == 1).length && !hasTruckTyre">
                                  <b-form-checkbox-group v-model="showGarageSelection" @input="setGarageSelect">
                                    <table class="table cart">
                                      <tbody>
                                      <tr v-for="(service, key) in additionalServices" :key="key">
                                        <template v-if="service.id == 1">
                                          <td class="product-list-first border-0">
                                            <div class=" custom-control custom-checkbox pl-1 mr-auto">
                                              <b-form-checkbox
                                                  :value="service.id"
                                                  v-model="installationServiceStatus"
                                                  @change="changeMounting"
                                              >
                                                <h4 class="font-14 pt-2 font-weight-normal float-left w-75"
                                                    v-html="(service.short_description).replace('{delivery_charges}', setCurrency(shipping_charge))"
                                                >
                                                </h4>
                                                <img @click="openFreeDeliveryPopup()" title="Click for get free shipping information" variant="primary" style="height: 50px;" :src="`/images/cart-popup/free-delivery-logo_wbg_${currentLang}.png`">
                                              </b-form-checkbox>
                                              <div class="font-14 mb-0" v-html="service.service_description"></div>
                                            </div>
                                          </td>
                                          <td data-label="" colspan="4" class="text-right pl-0 pr-0 border-0" >
                                            <p class="mb-0 font-12">{{ $t("lowest price for tyre fitment package at the moment Total") }} {{ calulateTotalServicePrice(service.minimum_price1) }}</p>
                                          </td>
                                        </template>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </b-form-checkbox-group>
                                </div>
                                <hr v-if="additionalServices.filter(additionalService => additionalService.id == 1).length">

                                <div class="optional-service">
                                  <table class="table cart">
                                    <tbody>
                                    <tr>
                                      <td class="product-list-first border-0">
                                        <div class="custom-control custom-checkbox pl-1 mr-auto">
                                          <b-form-checkbox
                                              v-model="showInformation"
                                              :value="true"
                                              :unchecked-value="false"
                                              @change="setInformation"
                                              class=""
                                          >
                                          <span v-if="hasTruckTyre" class="mb-0 font-16">{{ $t("Fast delivery from our local warehouse") }}</span>
                                          <span v-else v-html="(get_total_quantity ? $t('without_installation_text').replace('{delivery_price}', setCurrency(shipping_charge || '0.00')) : '')"></span>
                                          </b-form-checkbox>
                                          <ul class="font-14 mb-0 mt-2 ml-3 list-type-disk">
                                            <li class="mb-1">{{$t('without_installation_package_line_1')}}</li>
                                            <li class="mb-1">{{$t('without_installation_package_line_2')}}</li>
                                            <li class="mb-1">{{$t('without_installation_package_line_3')}}</li>
                                            <li class="mb-1" v-if="one_tyre_shipping_charge">{{
                                                (((($t('without_installation_package_line_4'))
                                                    .replace("{1_tyre_delivery_amount}", setCurrency(one_tyre_shipping_charge)))
                                                    .replace("{2_tyre_delivery_amount}", setCurrency(two_tyre_shipping_charge)))
                                                    .replace("{3_tyre_delivery_amount}", setCurrency(three_tyre_shipping_charge)))
                                                    .replace("{4_tyre_delivery_amount}", setCurrency(four_tyre_shipping_charge))
                                              }}
                                            </li>
                                          </ul>
                                        </div>

                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              <div v-if="hasProduct()">
                                <h2 v-if="additionalServices.filter(ser => ser.id !== 1).length > 0  && !hasTruckTyre">{{ $t("Additional Services") }}</h2>
                                <div class="optional-service"
                                     v-if="!servicesLoading && additionalServices.length > 0  && !hasTruckTyre">
                                  <b-form-checkbox-group
                                      v-model="showGarageSelection"
                                      @input="setGarageSelect"
                                  >
                                    <table class="table cart">
                                      <tbody>
                                      <tr v-for="( service, key ) in additionalServices" :key="key">
                                        <template v-if="service.id != 1">
                                          <td class="product-list-first">
                                            <div class="custom-control custom-checkbox pl-0 mr-auto">
                                              <b-form-checkbox :value="service.id">
                                                <h4 class="font-14 pt-2">
                                                  {{ service.service_name }}
                                                </h4>
                                                <p class="font-14 mb-0 font-italic ">
                                                  {{ service.service_description }}
                                                </p>
                                              </b-form-checkbox>
                                            </div>
                                          </td>
                                          <td data-label="" colspan="4" class="text-right pl-0 pr-0" v-if=" service.is_price_per_quantity == '1' ">
                                            <p class="mb-0 font-12">{{ $t("Starts from") }}</p>
                                            <p class="mb-0 font-12" v-for="(Amount, VehicleType) in formatServicePrice(service.minimum_price)" :key="VehicleType">
                                              {{ VehicleType }} : {{ Amount }} / {{ $t("unit") }}
                                            </p>
                                          </td>
                                          <td data-label="" colspan="4" class="text-right pl-0 pr-0" v-else>
                                            <p class="mb-0 font-12" v-for="(Amount, VehicleType) in formatServicePrice(service.minimum_price)" :key="VehicleType">
                                              {{ VehicleType }} : {{ Amount }}
                                            </p>
                                          </td>
                                        </template>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </b-form-checkbox-group>
                                </div>
                                <div v-if="servicesLoading">
                                  <div class="loading"></div>
                                </div>

                                <div v-if="showGarageSelection.length == 0 || hasTruckTyre"
                                     class="pl-3 d-flex justify-content-end">
                                  <button type="button" @click="removeCartServices()" class="bg-green btn font-weight-bold text-uppercase pt-2 pb-2"
                                          :disabled="showInformation == true && showGarageSelection.length == 0 ? false : true">
                                    {{ $t("Proceed to Information") }}
                                  </button>
                                </div>
                                <div v-if="showInformation == false && showGarageSelection.length > 0 && hasTruckTyre == false" class="pl-3 d-flex justify-content-end">
                                  <button
                                      type="button"
                                      @click="setSelectedServices()"
                                      class="bg-green btn font-weight-bold text-uppercase pt-2 pb-2"
                                      :disabled="!showGarageSelection"
                                  >
                                    <span v-if="!cartServiceLoading">
                                      <span v-if="selectedServicePoint !== null">{{ $t("Go to make an appointment") }}</span>
                                      <span v-else>{{ $t("Proceed to Service point selection") }}</span>

                                    </span>
                                    <span v-else class="loading"></span>
                                  </button>
                                </div>

                                <!-- <div v-if="showInformation" class="pl-3 d-flex justify-content-end">
                                                            <button type="button" @click="removeCartServices()"
                                                                class="bg-yellow btn font-weight-bold text-uppercase pt-2 pb-2">
                                                                {{ $t('Proceed to Information') }}
                                                            </button>
                                                        </div>
                                                        <div v-if="!showInformation" class="pl-3 d-flex justify-content-end">
                                                            <button type="button" @click="setSelectedServices()"
                                                                class="bg-yellow btn font-weight-bold text-uppercase pt-2 pb-2" :disabled="!showGarageSelection">
                                                                <span v-if="!cartServiceLoading">{{ $t('Proceed to Service point selection') }}</span>
                                                                <span v-else class="loading"></span>
                                                            </button>
                                                        </div> -->
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4 d-none d-lg-block d-xl-block">
                            <CartRightSideDesktop :hasProduct="hasProduct()" :updateCartLoading="updateCartLoading" :additionalServices="additionalServices" :installationServiceStatus="installationServiceStatus" :grand-total="(cartDetails.total || '0.00')" :shippingCharges="cartDetails.shipping_charges" :cartDetails="cartDetails" />
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab v-if="!hasTruckTyre"
                        name="Garage Selection"
                        :active="activeTab === 'Garage Selection'"
                        :title-link-class="{'current' : activeTab === 'Garage Selection', 'active_manual' : (getActiveTabClasses('Garage Selection').indexOf(activeTab) >= 0)}"
                        :disabled="!isActiveTab('Garage Selection')"
                        lazy
                    >
                      <template #title>
                        <div class="tab-title">
                          <div class="tab-number" ref="tabNumber">2</div>
                          <span>{{$t('Service Point selection')}}</span>
                        </div>
                      </template>
                      <a href="javascript:void(0);"
                         @click="setActiveTab('Cart')"
                         class="btn btn-link text-dark px-0"
                      ><i class="fa fa-angle-double-left mr-2"></i
                      >{{ $t("Cart") }}</a
                      >
                      <div class="row">
                        <div :class="{'col-lg-8' : hasProduct(), 'col-lg-12' : !hasProduct()}" class="col-sm-12">
                          <TabAppointments :services="selectedServices" :activetab="activeTab" :paymentStatus="paymentStatus" />
                        </div>
                        <div class="col-lg-4 d-none d-lg-block d-xl-block">
                          <CartRightSideDesktop :hasProduct="hasProduct()" :updateCartLoading="updateCartLoading" :additionalServices="additionalServices" :installationServiceStatus="installationServiceStatus" :grand-total="(cartDetails.total || '0.00')" :shippingCharges="cartDetails.shipping_charges" :cartDetails="cartDetails" />
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                        name="Information"
                        id="Information"
                        :active="activeTab === 'Information'"
                        :title-link-class="{'current' : activeTab === 'Information', 'active_manual' : (getActiveTabClasses('Information').indexOf(activeTab) >= 0)}"
                        :disabled="activeTab !== 'Information'"
                        lazy
                    >
                      <template #title>
                        <div class="tab-title">
                          <div class="tab-number" ref="tabNumber">
                            {{ hasTruckTyre ? "2" : "3" }}</div>
                          <span>{{$t('Information')}}</span>
                        </div>
                      </template>
                      <a href="javascript:void(0);" @click="setActiveTab('Garage Selection')" class="btn btn-link text-dark px-0" v-if="!showInformation">
                        <i class="fa fa-angle-double-left mr-2"></i>
                        {{ $t("Back to service point selection") }}
                      </a>
                      <a href="javascript:void(0);" @click="setActiveTab('Cart')" class="btn btn-link text-dark px-0" v-if="showInformation">
                        <i class="fa fa-angle-double-left mr-2"></i>{{ $t("Back to cart") }}
                      </a>
                      <div class="row">
                        <div :class="{'col-lg-8' : hasProduct(), 'col-lg-12' : !hasProduct()}" class="col-sm-12">
                          <TabUserInformation
                              :services="selectedServices"
                              :activeTab="activeTab"
                              :paymentStatus="paymentStatus"
                              :showShipping="showInformation"
                              :userDetails="userDetails"
                              :userDetailsAddress="userDetailsAddress"
                              :showServiceCenter="!hasTruckTyre" />
                        </div>
                        <div class="col-lg-4 d-none d-lg-block d-xl-block">
                          <CartRightSideDesktop :hasProduct="hasProduct()" :updateCartLoading="updateCartLoading" :additionalServices="additionalServices" :installationServiceStatus="installationServiceStatus" :grand-total="(cartDetails.total || '0.00')" :shippingCharges="cartDetails.shipping_charges" :cartDetails="cartDetails" />
                        </div>
                      </div>
                    </b-tab>
                    <b-tab name="Payment & Order Summary"
                           id="payment_and_order_summary"
                           :active="['Order Summary', 'Confirm'].indexOf(activeTab) !== -1"
                           :title-link-class="{
                              'current' : (['Order Summary', 'Confirm'].indexOf(activeTab) !== -1),
                              'active_manual' : (
                                  (getActiveTabClasses('Order Summary').indexOf(activeTab) >= 0 && !showInformation) ||
                                  (getActiveTabClasses('Confirm').indexOf(activeTab) >= 0)
                              )
                           }"
                           :disabled="['Order Summary', 'Confirm'].indexOf(activeTab) === -1"
                           lazy
                    >
                      <template #title>
                          <div class="tab-title">
                              <div class="tab-number" ref="tabNumber">
                                {{ hasTruckTyre ? "3" : "4" }}
                              </div>
                              <span>{{$t('Payment')}}</span>
                          </div>
                      </template>
                      <div v-if="$route.name === 'order-summary'">
                          <a href="javascript:void(0);" @click="setActiveTab('Information')" class="btn btn-link text-dark px-0">
                            <i class="fa fa-angle-double-left mr-2"></i>{{ $t("Back to information") }}
                          </a>
                          <div v-if="failedOrder && failedOrder.variant == 'danger'">
                            <bootstrap-alert
                                :variant="failedOrder.variant"
                                :msg="this.$t( 'Sorry your payment failed, please try again with different options')"
                                :errorMsg="failedOrder.errmsg"
                            />
                          </div>
                          <TabOrderSummary @update-tab="setCurrentTab" :showShipping="showInformation" />
                      </div>
                      <div v-if="$route.name === 'order-confirm'">
                          <TabOrderConfirm />
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script  src="https://apis.google.com/js/api.js" ></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA7IkglpRYrOiH_2__bS6dC9xz672zbNLY&libraries=places"></script>

<script>
import { mapGetters, mapActions } from "vuex";
import TabAppointments from "../components/TabAppointments";
import TabUserInformation from "../components/TabUserInformation";
import TabOrderSummary from "../components/TabOrderSummary";
import TabOrderConfirm from "../components/TabOrderConfirm";
import CartRightSidebarPopupMobile from "./CartRightSidebarPopupMobile"
import CartRightSideDesktop from "./CartRightSideDesktop"

export default {
  metaInfo: {
    title: "Cart Page",
    meta: [
      { charset: "utf-8" },
      { name: "title", content: "Cart Page" },
      { name: "description", content: "This is my cart page" },
      { name: "keywords", content: "renkaatalle, Renkaatalle.fi, cart" },
      { name: "robots", content: "index,follow" },
    ],
    link: [{ rel: "canonical", href: process.env.VUE_APP_BASE_URL + "cart" }],
  },
  data() {
    return {
      promocodeEmpty: false,
      processingPayment: false,
      showInformation: false,
      showGarageSelection: ["1"],
      activeTab: this.activeTab ? this.activeTab : "Cart",
      userDetailInfo: [],
      paymentStatus: null,
      moneySign: "€",
      orderNumber: null,
      totalRecycleQty: 0,
      selectedServices: "",
      updateCartLoading: false,
      failedOrder: {},
      removeServices: false,
      quantityError: [],
      productUpdateError: [],
      removeLoading: false,
      promocodeDiscount: this.promocode != null ? this.promocode : null,
      promocodeApplied: false,
      installationServiceStatus: ["1"],
      promocodeToggle: false,
      variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
      headerBgVariant: 'dark',
      cmsPageupdateContent: '',
      isDisplaySidebar  : false,
      hasTruckTyre: false,
    };
  },
  beforeMount() {
    if (this.$route.name == "order-summary") {
      this.activeTab = "Order Summary";
      if (this.$route.query.ORDER_NUMBER) {
        this.setActiveTab("Order Summary", {
          orderNumber: this.$route.query.ORDER_NUMBER,
        });
      } else if (this.$route.params.orderNumber) {
        this.setActiveTab("Order Summary", {
          orderNumber: this.$route.params.orderNumber,
        });
      }
    }
  },
  watch: {
    showInformation: {
      immediate: true,
      handler(newValue) {
        this.showInformation = newValue;
      },
    },
    selectedServices: {
      immediate: true,
      handler(newValue) {
        this.selectedServices = newValue;
      },
    },
    activeTab: {
      handler(newValue) {
        this.activeTab = newValue;
      },
    },
    cartId: {
      immediate: true,
      handler(newValue) {
        this.setCartId(newValue)
      },
    },
    orderNumber: {
      immediate: true,
      handler(newValue) {
        this.orderNumber = newValue;
      },
    },
    $route: {
      handler(newValue) {
        if (this.$route.name == "order-summary") {
          this.activeTab = "Order Summary";
          if (this.$route.query.ORDER_NUMBER) {
            this.setActiveTab("Order Summary", {
              orderNumber: this.$route.query.ORDER_NUMBER,
            });
          } else if (this.$route.params.orderNumber) {
            this.setActiveTab("Order Summary", {
              orderNumber: this.$route.params.orderNumber,
            });
          }
        }
        if (this.$route.name == "cart-user-info") {
          this.activeTab = "Information";
        }
        if (this.$route.name == "order-confirm") {
          this.activeTab = "Confirm";
        }
        if (this.$route.name == "cart") {
          this.activeTab = "Cart";
        }
        if (this.$route.name == "dealer-services") {
          this.activeTab = "Garage Selection";
        }
      },
    },
    paymentStatus: {
      immediate: true,
      handler(newValue) {
        this.paymentStatus = newValue;
      },
    },
    selectedServicePoint: {
      immediate: true,
      handler(newValue) {
        if (['cart', 'order-summary', 'cart-user-info', 'dealer-services'].indexOf(this.$route.name) === -1) {
          return;
        }
        if (this.hasProduct() && !this.hasTruckTyre) {
          this.getAdditionalServices({lang : this.currentLang, dealer_id : newValue && typeof newValue == "object" ? newValue.id : null, newValue : newValue});
        }
      },
    },
    currentLang: {
      handler(newVal) {
        if (['cart', 'order-summary', 'cart-user-info', 'dealer-services'].indexOf(this.$route.name) === -1) {
          return;
        }
        if (this.hasProduct()) {
          this.getAdditionalServices({
            lang: newVal,
            dealer_id: this.selectedServicePoint && typeof this.selectedServicePoint == "object" ? this.selectedServicePoint.id : null
          });
        }
      },
    },
    installationServiceStatus: {
      handler(newVal) {
        this.InstallationServiceStatusHandler(newVal)
      },
    },
    additionalServices: {
      handler(newVal) {
        if (newVal.length === 0) {
          this.showGarageSelection = [];
          this.installationServiceStatus = [];
          this.showInformation = true;
          localStorage.removeItem("service");
          this.csSetIsWithService(false);
        }
      }
    },

  },
  async created() {
    this.failedOrder = {};
    await this.checkPaymentInformation();
    await this.checkKlarnaPaymentInformation();
    await this.handleKlarnaHPPSession();
    this.moneySign = process.env.VUE_APP_CURRENCY_SIGN;
    this.removeExistingAppointmentIfSelectedDealerIsNew();
    await this.getCartDetails();
    this.resetPromocodeError();

    this.showShippingInfo();

    await this.getShippingCharge(this.get_total_quantity)
    const response = this.getCmsPageContent({pageName:  "free-shipping-information", lang: (this.currentLang == "fi_FI" ? 2 : 1)});

    if ("is_with_service" in localStorage) {
      const is_with_service = localStorage.getItem("is_with_service");
      if (is_with_service == 'yes') {
        this.csSetIsWithService(true);
      } else {
        this.csSetIsWithService(false);
      }
    }
    /* handle service once transcation failed */
    if ("service" in localStorage) {
      if(localStorage.getItem("service")) {
          var services = localStorage.getItem('service').split(',');

          this.showGarageSelection = services;
          this.installationServiceStatus = services;
          if (services.length) {
            this.csSetIsWithService(true);
          }
      } else {
        if (this.paymentStatus == "failed") {
          this.showGarageSelection = [];
          this.installationServiceStatus = [];
          this.showInformation = true;
        } else {
          localStorage.setItem("service", '1');
          this.csSetIsWithService(true);
        }
      }
    } else {
      if (this.paymentStatus == "failed") {
        this.showGarageSelection = [];
        this.installationServiceStatus = [];
        this.showInformation = true;
      } else {
        if(!this.hasTruckTyre) {
            localStorage.setItem("service", '1');
            this.csSetIsWithService(true);
          }
        }
    }
    /* handle service once transcation failed */

    if (this.paymentStatus == null) {
      this.removeInstallationShippingCharges().finally(() => {
        this.getAllCartProducts().finally(() => {
          this.updateCartLoading = false;
        });
      });
    }

    /* handle promo code once transcation failed */
    if (localStorage.getItem("promocode")) {
      this.promocodeToggle = true;
    }

    if (this.hasProduct() && !this.hasTruckTyre) {
      this.getAdditionalServices({lang: this.currentLang, dealer_id : this.selectedServicePoint && typeof this.selectedServicePoint == "object" ? this.selectedServicePoint.id : null});
    }
    /* handle promo code once transcation failed */

  },
  mounted() {
    $(".form-control").removeAttr("readonly");

    if(this.activeTab == "Cart" && this.orderNumber == null && this.paymentStatus == null) {
     /*this.$refs['my-modal'].show();*/
    }

    // setTimeout(() => {
    //   $(".modal-dialog-scrollable .modal-body").css("overflow-y", "auto");
    //   $(".modal-dialog-scrollable .modal-body").css("height", "800px");
    //   $(".modal-title").css("color", "black");
    // }, 100);

    setTimeout(() => {

        if(this.cmsPageContent.content != undefined){
          // this.cmsPageContent.content

          let pageCtn = this.cmsPageContent.content.split("<p>");
          let content = "";

          if (pageCtn.length > 1) {
            var ctn = 1;
            pageCtn.forEach( function(shippingInfo) {
              if(shippingInfo != "")  {

                // content += shippingInfo.replace("</p>", "");

                content += '<p>';
                  content +='<div class="modal-number">'+ctn+'</div>';
                  content +='<div style="padding-top: 10px;">'+shippingInfo.replace("</p>", "")+'</div>';
                  content +='</p>';

                ctn++;
              }
            });

            this.cmsPageupdateContent = content;

          }
        }
    },1000);
  },
  computed: {
    ...mapGetters("app", ["currentLang"]),
    ...mapGetters("auth", ["userDetails", "userDetailsAddress"]),
    ...mapGetters("cart", ["rimSizes", "cartProducts", "cartDetails", "cartId", "promoLoading", "promocode", "promocodeErrors"]),
    ...mapGetters("order", ["orderDetails", "paymentDetails", "confirmLoading", "paymentConfirmation", "klarna_hpp_session"]),
    ...mapGetters("services", ["additionalServices", "servicesLoading", "cartServiceLoading",]),
    ...mapGetters("cmspage", ["cmsPageContent", "loading", "response","isShow"]),
    ...mapGetters("cart_right_sidebar", ["is_with_service", "cs_dealer"]),
    ...mapGetters("appointments", ["appointmentCached"]),
    ...mapGetters("search_dealer", ["selectedServicePoint"]),
    ...mapGetters('shipping_charge',['shipping_charge', 'one_tyre_shipping_charge', 'two_tyre_shipping_charge', 'three_tyre_shipping_charge','four_tyre_shipping_charge']),
    get_total_quantity() {
      var defaultQuantity = 1, productQuantity = 0;
      if (this.hasProduct()) {
        this.cartProducts.forEach((Product, PIndex) => {
          productQuantity += Product.qty
        })
      }
      return productQuantity === 0 ? defaultQuantity : productQuantity;
    }
  },
  components: {
      TabAppointments,
      TabUserInformation,
      TabOrderSummary,
      TabOrderConfirm,
      CartRightSidebarPopupMobile,
      CartRightSideDesktop
  },
  methods : {
    ...mapActions("cart", [
      "addProduct", "updateQuantity", "getAllCartProducts",
      "removeCartProduct", "removeAllCartServices", "setCartId",
      "applyPromocode", "removePromocode",
      "setPromocodeErrors", "resetPromocode",
      "resetPromocodeError", "addInstallationShippingCharges",
      "removeInstallationShippingCharges", "updatePaytrailStatus",
    ]),
    ...mapActions("services", ["getAdditionalServices", "addServicesInCart"]),
    ...mapActions("order", ["confirmPaymentWithPaytrail", "resetError", "confirmOrderWithPaytrail", "confirmPaymentWithKlarna", "readKlarnaHPPSession"]),
    ...mapActions("cmspage", ["getCmsPageContent"]),
    ...mapActions("cart_right_sidebar", ["csRemoveDealerFromLocalStorage", "csSetIsWithService", "csWORemoveDealerFromLocalStorage", "getLiveCart"]),
    ...mapActions("appointments", ["addAppointment", "getAppointmentCached", "setAppointmentCached"]),
    ...mapActions('search_by_service_point', ['removeOlderAppointment']),
    ...mapActions('shipping_charge',['getShippingCharge']),
    async showShippingInfo() {
      if (this.hasProduct()) {
         this.hasTruckTyre = this.cartProducts.some(product => product.vehicle_type === 'Truck');

         if(this.hasTruckTyre){
          if(!this.showInformation){
            this.showInformation = true
          }
            this.showGarageSelection = (this.showInformation) ? [] : ['1'];
            this.csSetIsWithService(false);
            this.installationServiceStatus = [];
            localStorage.removeItem("service");
         } else {
          this.changeMounting(true)
          this.showInformation = false;
          localStorage.setItem("service", 1);
         }
      }
    },
    async handleKlarnaHPPSession() {
      if (this.$route.query.sid && this.$route.params.orderNumber) {
        var fromData = new FormData;
        fromData.append("klarna_hpp_session_id", this.$route.query.sid)
        fromData.append("order_number", this.$route.params.orderNumber)
        await this.readKlarnaHPPSession(fromData)
        this.activeTab = "Order Summary";
        this.failedOrder = {
          variant: "danger"
        }
        this.setActiveTab("Order Summary", {
          orderNumber: this.$route.params.orderNumber,
        });
      }
    },
    getActiveTabClasses(ActiveTabName) {
      var ActiveTabNames = {
        'Cart': ['Cart', 'Garage Selection', 'Information', 'Order Summary', 'Confirm'],
        'Garage Selection':['Garage Selection', 'Information', 'Order Summary', 'Confirm'],
        'Information': ['Information', 'Order Summary', 'Confirm'],
        'Order Summary': ['Order Summary', 'Confirm'],
        'Confirm': ['Confirm']
      }
      return ActiveTabNames[ActiveTabName];
    },
    calulateTotalServicePrice(PriceData) {
      var package_price = 0.00;
      var PriceData = JSON.parse(PriceData);
      var that = this;
      Object.entries(PriceData).forEach(function([car_type_rim_size, price]) {
        var extract = car_type_rim_size.split("-");
        var car_type = extract[0];
        var rim_size = extract[1];
        if (that.hasProduct()) {
          that.cartProducts.forEach((Product, PIndex) => {
            if (Product.vehicle_type == car_type && Product.diameter == rim_size) {
              if (price !== null && price >= 0) {
                var sub_price = Product.qty * parseFloat(price)
                package_price = package_price + sub_price;
              }
            }
          })
        }
      })

      return this.formatPrice(package_price);
    },
    async removeExistingAppointmentIfSelectedDealerIsNew() {
      if (this.hasProduct() && ['cart', 'order-summary', 'cart-user-info', 'dealer-services'].indexOf(this.$route.name) !== -1) {
        await this.getAppointmentCached();
        if (this.is_with_service && this.appointmentCached != null && this.selectedServicePoint !== "" && this.selectedServicePoint !== null && this.appointmentCached.dealer_id !== this.selectedServicePoint.dealer_id) {
          this.removeOlderAppointment().finally(() => {
            this.setAppointmentCached(null);
            localStorage.removeItem("appointment");
            this.csRemoveDealerFromLocalStorage();
            this.csWORemoveDealerFromLocalStorage();
          });
        }
      }
    },
    async checkPaymentInformation() {
      if (this.$route.params.status) {
        if (
          this.$route.params.status &&
          this.$route.params.status.search("success") > -1
        ) {
          this.paymentStatus = "success";
          this.$router.push({ name: "page-not-found-redirect", replace: true });
        } else if (
          this.$route.params.status &&
          this.$route.params.status.search("failed") > -1
        ) {
          this.paymentStatus = "failed";

          const parameters = this.$route.query;
          const result = Object.keys(parameters);
          const updateKey = new Object();
          result.forEach((value, index) => {
            let abc = value.split("-").join("_");

            updateKey[abc] = parameters[value];
          });

          const orderIdDet = updateKey.checkout_stamp.split("-");

          if (this.$route.query && updateKey.checkout_stamp) {
            await this.updatePaytrailStatus(orderIdDet[0]).finally(() => {});

            this.activeTab = "Order Summary";
            this.failedOrder = {
              variant: "danger",
              message: this.$t("Sorry your payment failed, please try again with different options"),
            };
            this.setActiveTab("Order Summary", {orderNumber: orderIdDet[0]});
          }
        } else if (
          this.$route.params.status &&
          this.$route.params.status.search("confirm") > -1
        ) {
          this.paymentStatus = "confirm";
          //this.activeTab = "Confirm"
          if (this.$route.query) {
            await this.confirmPayment(this.$route.query);
          }
        }
      }
    },
    async checkKlarnaPaymentInformation() {
      if (this.$route.name === 'klarna-payment-verification') {
          if (this.$route.query.token && this.$route.query.sid && this.$route.query.order_id) {
              var FromData = new FormData;
              FromData.append("token", this.$route.query.token)
              FromData.append("sid", this.$route.query.sid)
              FromData.append("order_id", this.$route.query.order_id)
              await this.confirmPaymentWithKlarna(FromData)
                  .then(() => {
                    if (process.env.VUE_APP_EXECUTE_GTAG === 'true') {
                      var gtag_products = [];
                      this.cartDetails.line_items.forEach(function (product) {

                        if (product.type == "product") {
                          gtag_products.push({
                            'item_id': product.id,
                            'item_name': product.product.name,
                            'affiliation': product.type,
                            'price': product.unit_price,
                            'type_id': product.type_id,
                            'quantity': product.quantity,
                            'item_category': product.product.car_type
                          })
                        }
                      })

                      // gtag add payment info
                      this.googleTagAddPaymentInfo(this.paymentConfirmation, "Klarna Payment", gtag_products);

                      // gtag add purchase
                      this.googleTagPurchase(this.paymentConfirmation, this.cartDetails.shipping_charges, gtag_products)
                    }
                    localStorage.removeItem('service');
                    localStorage.removeItem("promocode");

                    this.paymentStatus = "confirm";
                    this.activeTab = "Confirm";

                    var orderNumber = this.paymentConfirmation.order_number
                    this.$router.push({
                      path: `/cart/confirmation/${orderNumber}`,
                      replace: true,
                    });
                  })
                  .finally(() => {
                    this.manageLocalStorageAfterSuccessfulPayment()
                  });
          } else {
            this.$router.push({ name: "page-not-found-redirect", replace: true });
          }
      }
    },
    async getCartDetails() {
      this.updateCartLoading = true;
      await this.getAllCartProducts().finally(() => {
        this.updateCartLoading = false;
        this.promocodeDiscount = this.promocode;

        const cartProductList = [];

        if (this.cartDetails != null && typeof this.cartDetails.line_items == 'object') {
          this.cartDetails.line_items.forEach(function(cartDetail, key) {

            const cart_products = new Object();

            if (cartDetail.type == "product") {
              // cart_products[key].item_id = cartDetail.type_id;
              // cart_products[key].item_name = cartDetail.product.name;
              // cart_products[key].price = cartDetail.sub_total;
              // cart_products[key].quantity = cartDetail.quantity;
              // cart_products[key].type_id = cartDetail.type_id;

              cart_products.item_id = cartDetail.type_id;
              cart_products.item_name = cartDetail.product.name;
              cart_products.price = cartDetail.sub_total;
              cart_products.quantity = cartDetail.quantity;
              cart_products.type_id = cartDetail.type_id;
              cart_products.item_category = cartDetail.product.car_type;

              cartProductList.push(cart_products);
            }
          })

          this.googleTagViewCart(this.cartDetails.total, cartProductList);
        }


        // this.$gtag.event("view_cart", {
        //   currency: "€",
        //   value: this.cartDetails.total,
        //   items: cartProductList
        // });
      });
    },
    getShippingDetails() {
      let shipping = [];
      if (this.cartDetails && this.cartDetails.line_items) {
        shipping = _.find(this.cartDetails.line_items, { type: "service" });
      }
      return this.cartDetails;
    },
    /* totalPrice() {
            let totalprice = 0;
            totalprice = _.reduce(this.cartProducts, function(total, product) {
                return total + product.net_price*product.qty;
            }, 0);
            totalprice = parseFloat(totalprice).toFixed(2)
            return totalprice.replace(".", ",");
        }, */
    hasProduct() {
      return this.cartProducts.length > 0;
    },
    async removeProduct(product) {
      this.removeLoading = true;
      this.updateCartLoading = true;
      await this.removeCartProduct(product)
      this.googleTagRemoveFromCart(product)

      // this.$gtag.event('remove_from_cart', {
      //     currency: "€",
      //     value: product.net_price,
      //     items: [{
      //         'item_id': product.type_id,
      //         'item_name': product.name,
      //         // 'page_title': product.name,
      //         'price': product.net_price,
      //         // 'net_price': product.net_price,
      //         // 'qty': product.qty,
      //         'quantity': product.qty,
      //         'type_id': product.type_id
      //     }]
      // })
      await this.IsExecuteIfInstallationServiceExists();
      this.showShippingInfo();

      this.getCartDetails();
      this.getLiveCart();
      this.getShippingCharge(this.get_total_quantity)
      this.removeLoading = false;
    },
    productInput(product) {
      if (isNaN(product.qty)) {
        product.qty = 1;
      } else if (product.qty === "") {
        product.qty = 1;
      } else if (product.qty === 0) {
        product.qty = 1;
      }
    },
    async productUpdate(product) {
      if (isNaN(product.qty)) {
        product.qty = 1;
      }

      if (parseInt(product.qty) == 0) {
        product.qty = 1;
      }

      if (parseInt(product.qty) > parseInt(product.available_quantity)) {
        product.qty = product.available_quantity;
      }
      this.productUpdateError[product.id] = "";
      this.updateCartLoading = true;
      try {
        await this.addProduct(product)
        await this.IsExecuteIfInstallationServiceExists()
        //await this.updateCartIfOrderConfirm()
        await this.getAllCartProducts()
        this.getShippingCharge(this.get_total_quantity)
        this.getLiveCart()
      } catch (error) {
        this.productUpdateError[product.id] = error.response.data.errors[0];
      }
      this.updateCartLoading = false;
      /*this.addProduct(product)
        .catch((error) => {
          this.productUpdateError[product.id] = error.response.data.errors[0];
        })
        .finally(() => {
          this.getAllCartProducts().finally(() => {
            this.updateCartLoading = false;
          });
        });*/
    },
    /* setInformation(event) {
            if(event.target.checked) {
                this.$nextTick(() => {
                    this.showInformation = true
                    $("input[id^='service-']").prop('checked',false)
                })
            } else {
                this.$nextTick(() => {
                    this.showInformation = false

                })
            }

        }, */
    setInformation(checked) {
      if (checked) {
        this.showGarageSelection = [];
        this.csSetIsWithService(false);
      }
      this.installationServiceStatus = checked ? [] : ["1"];
    },
    changeMounting(checked) {
        this.showInformation = !checked;
        if (checked) {
          this.csSetIsWithService(true);
          localStorage.setItem("shippingAddressType", "billing")
        }
    },
    /* setGarageSelect(event) {
            if(event.target.checked) {
                this.$nextTick(() => {
                    this.showInformation = false
                    this.showGarageSelection = true
                    $("#womounting").prop("checked", false);
                })
            }
            else {
                this.$nextTick(() => {
                    this.showGarageSelection = false
                })
            }
        }, */
    setGarageSelect(event) {
      if (this.showGarageSelection.length > 0) {
        this.showInformation = false;
      }
    },
    setActiveTab(tabName, routeParams = [], boolQueryString = true) {
      this.activeTab = tabName;
      this.resetError();
      if ( tabName == "Order Summary" && typeof routeParams.orderNumber !== "undefined" ) {
        var orderSummaryRoute =  {
          path: "/cart/order-summary/" + routeParams.orderNumber,
          name: "order-summary",
          component: TabOrderSummary,
          params: routeParams,
          replace: true,
        }
        if (boolQueryString && this.$route.query.sid) {
          orderSummaryRoute.query = {sid : this.$route.query.sid}
        }
        this.$router.push(orderSummaryRoute);
      }
      if (tabName == "Information") {
        this.$router.push({
          path: "/cart/user-info",
          params: {},
          replace: true,
        });
      }

      if (tabName == "Garage Selection") {
        this.$router.push({
          path: "/cart/dealer-services",
          name: "dealer-services",
          params: {},
        });
        window.scrollTo(0, 0);
      }
      if (tabName == "Cart") {
        this.updateCartLoading = true;
        this.getAllCartProducts().finally(() => {
          this.updateCartLoading = false;
        });
        this.$router.push({
          path: "/cart",
          params: {},
        });
      }
    },
    calculatePrice(price, qty) {
      let productPrice = !isNaN(price) ? price : 0;
      let productQty = !isNaN(qty) ? qty : 0;
      let total = 0;
      total = productPrice * productQty;
      total = parseFloat(total).toFixed(2);
      let finalAmount = this.setCurrency(total);
      // return (total).toString().replace(".", ",")
      return finalAmount;

      // return productPrice * productQty
    },
    setCurrency(total) {
      if (total) {
        total = parseFloat(total).toFixed(2);
      }
      return total.replace(".", ",") + " " + this.moneySign;
    },
    async confirmPayment(paymentDetails) {
      const parameters = this.$route.query;
      const result = Object.keys(parameters);

      const updateKey = new Object();

      result.forEach((value, index) => {
        // let abc = value.replace("-", "_");

        let abc = value.split("-").join("_");

        updateKey[abc] = parameters[value];
      });

      let formData = new FormData();

      // formData.append('order_number', this.$route.query.ORDER_NUMBER);
      // formData.append('timestamp', this.$route.query.TIMESTAMP);
      // formData.append('paid', this.$route.query.PAID);
      // formData.append('method', this.$route.query.METHOD);
      // formData.append('return_auth_code', this.$route.query.RETURN_AUTHCODE);

      formData.append("checkout_account", updateKey.checkout_account);
      formData.append("checkout_algorithm", updateKey.checkout_algorithm);
      formData.append("checkout_amount", updateKey.checkout_amount);
      formData.append("checkout_stamp", updateKey.checkout_stamp);
      formData.append("checkout_reference", updateKey.checkout_reference);
      formData.append("checkout_status", updateKey.checkout_status);
      formData.append("checkout_provider", updateKey.checkout_provider);
      formData.append(
        "checkout_transaction_id",
        updateKey.checkout_transaction_id
      );
      formData.append("signature", updateKey.signature);

      await this.confirmPaymentWithPaytrail(formData)
        .then(() => {
          if (process.env.VUE_APP_EXECUTE_GTAG === 'true') {
            var gtag_products = [];
            this.cartDetails.line_items.forEach(function (product) {

              if (product.type == "product") {
                gtag_products.push({
                  'item_id': product.id,
                  'item_name': product.product.name,
                  'affiliation': product.type,
                  'price': product.unit_price,
                  'type_id': product.type_id,
                  'quantity': product.quantity,
                  'item_category': product.product.car_type
                })
              }
            })

            // gtag add payment info
            this.googleTagAddPaymentInfo(this.paymentConfirmation, updateKey.checkout_provider, gtag_products);

            // gtag add purchase
            this.googleTagPurchase(this.paymentConfirmation, this.cartDetails.shipping_charges, gtag_products)
          }
          localStorage.removeItem('service');
          localStorage.removeItem("promocode");

          // this.$gtag.event("purchase", {
          //     transaction_id: this.paymentConfirmation.order_number,
          //     affiliation: "Webshop",
          //     value: this.paymentConfirmation.total,
          //     tax: this.paymentConfirmation.vat_amount,
          //     shipping: 5.99,
          //     currency: "€",
          //     coupon: "",
          //     items: gtag_products
          // });

          this.paymentStatus = "confirm";
          this.activeTab = "Confirm";

          //this.orderNumber = this.$route.query.ORDER_NUMBER
          var orderNumber = this.paymentConfirmation.order_number
          this.$router.push({
            path: `/cart/confirmation/${orderNumber}`,
            replace: true,
          });


        })
        .finally(() => {
          this.manageLocalStorageAfterSuccessfulPayment()
        });
    },
    async removeQuantity(product, index) {
      this.quantityError[product.id] = false;
      if (product.qty == 1) {
        return false;
      } else {
        this.updateCartLoading = true;
        product.qty = product.qty - 1;
        this.productUpdateError[product.id] = "";
        try {
          await this.addProduct(product)
          await this.IsExecuteIfInstallationServiceExists()
          //await this.updateCartIfOrderConfirm()
          await this.getAllCartProducts()
          this.getShippingCharge(this.get_total_quantity)
          this.getLiveCart()
        } catch (error) {
          this.productUpdateError[product.id] = error.response.data.errors[0];
        }
        this.updateCartLoading = false;
        /*this.addProduct(product)
          .catch((error) => {
            this.productUpdateError[product.id] = error.response.data.errors[0];
          })
          .finally(() => {
            this.getAllCartProducts().finally(() => {
              this.updateCartLoading = false;
            });
          });*/
      }
    },
    async addQuantity(product, index) {
      if (product.qty == product.available_quantity) {
        this.updateCartLoading = true;
        this.quantityError[product.id] = true;
        this.updateCartLoading = false;
        return false;
      } else {
        this.quantityError[product.id] = false;
        this.updateCartLoading = true;
        product.qty = product.qty + 1;
        this.productUpdateError[product.id] = "";
        try {
          await this.addProduct(product)
          await this.IsExecuteIfInstallationServiceExists()
          //await this.updateCartIfOrderConfirm()
          await this.getAllCartProducts()
          this.getShippingCharge(this.get_total_quantity)
          this.getLiveCart()
        } catch (error) {
          this.productUpdateError[product.id] = error.response.data.errors[0];
        }
        this.updateCartLoading = false;
        /*this.addProduct(product)
          .catch((error) => {
            this.productUpdateError[product.id] = error.response.data.errors[0];
          })
          .finally(() => {
            this.getAllCartProducts().finally(() => {
              this.updateCartLoading = false;
            });
          });*/
      }
    },
    setCurrencyRecyclingTotalQty() {
      let totalRecycleQty = 0;
      this.cartProducts.find((el) => {
        totalRecycleQty = totalRecycleQty + parseInt(el.qty);
      });
      if (isNaN(totalRecycleQty)) {
        totalRecycleQty = 0;
      }
      this.totalRecycleQty = totalRecycleQty;
      return this.totalRecycleQty;
    },
    setSelectedServices() {
      /* let arrSelectedServices = []
            for(let sel in this.additionalServices) {
                if($("#service-"+sel).is(":checked")){
                    arrSelectedServices.push($("#service-"+sel).val())
                }
            }
            this.selectedServices = '[' + _.join(_.uniq(arrSelectedServices), [',']) + ']' */
      this.selectedServices = "[" + this.showGarageSelection.toString() + "]";
      this.setActiveTab("Garage Selection");
    },
    removeCartServices() {
      if (this.cartProducts.length > 0) {
        this.removeAllCartServices();
      }
      this.setActiveTab("Information");
    },
    isActiveTab(tabName) {
      return this.activeTab === tabName;
    },
    setCurrentTab(tabName) {
      this.activeTab = tabName;
    },
    applyCode() {
      if (this.promocodeDiscount) {
        this.promocodeEmpty = false;
        let formData = new FormData();
        let currentSelectedLang = String(this.currentLang);
        formData.append("promo_code", this.promocodeDiscount);
        formData.append(
          "locale",
          currentSelectedLang.substring(0, currentSelectedLang.indexOf("_"))
        );
        this.applyPromocode(formData).finally(() => {

          localStorage.setItem("promocode", this.promocodeDiscount);

          this.promocodeApplied = true;
          this.getAllCartProducts();
          this.$nextTick();
        });
      } else {
        this.promocodeEmpty = true;
      }
    },
    gotoListPage() {
      this.$router.push(this.go_to_products())
    },
    removeCode() {
      if (this.promocodeDiscount !== "") {
        if (this.promocodeDiscount != this.promocode) {
          this.setPromocodeErrors({
            message: "One or more validation errors occurred",
            errors: ["Invalid promo code"],
          });
        }

        this.removePromocode().finally(() => {
          localStorage.removeItem("promocode");
          this.getAllCartProducts();
          this.promocodeApplied = false;
          this.promocodeDiscount = null;
          this.resetPromocode();
        });
      }
    },
    getServiceName(service) {
      let serviceName = "";
      for (let [key, value] of Object.entries(service.translations)) {
        if (value.locale_code == this.currentLang) {
          serviceName = value.name;
        }
      }

      return serviceName;
    },
    openFreeDeliveryPopup() {
      this.$refs['my-modal'].show();
    },
    formatServicePrice(ServicePriceObjectString) {
      let parsedObject = JSON.parse(ServicePriceObjectString);
      let Obj = {};
      Object.keys(parsedObject).forEach(key => {
          if (parsedObject[key] == null){
            //console.log(delete(parsedObject, key))
          } else {
            Obj[key] = this.setCurrency(parsedObject[key].toString());
          }
      })
      return Obj;
    },
    async InstallationServiceStatusHandler(newVal) {

      if(!this.hasTruckTyre){
        localStorage.setItem("service", newVal);
      }
      this.updateCartLoading = true;
      if (newVal.length) {
        await this.removeInstallationShippingCharges()
        localStorage.setItem("shippingAddressType", "billing")
        //await this.updateCartIfOrderConfirm()
        await this.getAllCartProducts()
        if (this.hasProduct() && ['cart', 'order-summary', 'cart-user-info', 'dealer-services'].indexOf(this.$route.name) !== -1) {
          this.getLiveCart()
        }
        this.updateCartLoading = false;
      } else {
        this.addInstallationShippingCharges().finally(() => {
          this.removeAllCartServices().finally(() => {
            this.getAllCartProducts().finally(() => {
              if (this.hasProduct() && ['cart', 'order-summary', 'cart-user-info', 'dealer-services'].indexOf(this.$route.name) !== -1) {
                this.getLiveCart()
              }
              this.updateCartLoading = false;
            });
          });
        });
      }
    },
    async updateCartIfOrderConfirm() {
      if (this.is_with_service === true && this.cs_dealer.name !== '') {
        await this.confirmOrderWithPaytrail()
        if(localStorage.getItem('dealerservice') && localStorage.getItem('appointment')) {
          let appointment = JSON.parse(localStorage.getItem("appointment"));
          await this.getAppointmentCached()
          await this.addAppointment(appointment)
          await this.getAllCartProducts()
        }
      } else {
        await this.getAllCartProducts()
      }
    },
    async IsExecuteIfInstallationServiceExists() {
      if (this.installationServiceStatus.length) {
        await this.removeInstallationShippingCharges()
      }
    },
    manageLocalStorageAfterSuccessfulPayment() {
      localStorage.removeItem("anonymous");
      if(!this.hasTruckTyre) {
        localStorage.setItem("service", '1');
      }

      localStorage.removeItem("setSearchedZipcode");
      localStorage.removeItem("address");
      localStorage.removeItem("dealerservice");
      localStorage.removeItem("appointment");
      localStorage.removeItem("setDealerServiceApiParamsCached");
      localStorage.removeItem("tempAddress");
      localStorage.removeItem("shippingDetails");
      localStorage.removeItem("billingDetails");
      localStorage.removeItem("setDealerServiceApiParamsCachedWS");
      localStorage.removeItem("cart_shipping_address");
      localStorage.removeItem("cart_shipping_temp_address");
      localStorage.removeItem("setShippingDetailsToCached");
      localStorage.removeItem("shippingAddressType");
      localStorage.removeItem("cs_dealer");
      localStorage.removeItem("cs_dealer_without_service");
      localStorage.removeItem("is_with_service");
      localStorage.removeItem('order_note');
      localStorage.removeItem('licencePlate');
      localStorage.removeItem('payment_by');
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.promo-code { width: 150px; }
.promo-error { color: red; }
input[type="number"] { -moz-appearance: textfield; }
.set-font-size {
  font-size: 0.9em;
}
.modal-body {
  overflow-y: auto !important;height: 200px !important;
}
.modal-title {
  color: black;
}
#cart-freeinstallition-modal .modal-header {
  color: black !important;border-bottom: 3px solid #da9d26 !important;
}
.checkout-cart .card-body .card-header .nav-link .tab-title {
  position: relative; display: flex; flex-direction: column; align-items: center;
}
.checkout-cart .card-body .card-header .nav-link.active_manual .tab-title {
    color: #28A745 !important;
}
.checkout-cart .card-body .card-header .nav-link.current.active_manual .tab-title {
  color: #28A745 !important; font-weight: bold;
}
.checkout-cart .card-body .card-header .nav-link .tab-number {
  position: absolute;width: 20px; height: 20px; top: -30px;font-weight: bold;border-radius: 20px;text-align: center;
}
.checkout-cart .card-body .card-header .nav-link .tab-number {
  background-color: #e2e2e2;color: #555;
}
.checkout-cart .card-body .card-header .nav-link.active_manual .tab-number {
  background-color: #28A745;color: #fff;
}
.checkout-cart .card-body .card-header .nav-link.current.active_manual .tab-number {
  background-color: #28A745;color: #fff;
}
</style>